<div class="view-header">
  <h1 class="view-title">Dashboard</h1>
  <p class="view-subtitle">Welcome back! Here's your hiring overview.</p>
</div>

<!-- Summary Statistics Grid -->

<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <section class="stats-grid">
    <div class="stats-card">
      <div class="stats-card-left">
        <span class="stats-label">Total Jobs Posted</span>
        <span class="stats-value">{{ stats.totalJobs }}</span>
        <!-- <span class="stats-trend trend-positive">
          +{{ dashboardData?.total_jobs_posted?.delta || 0 }}
          {{ dashboardData?.total_jobs_posted?.delta_label }}
        </span> -->
      </div>
      <div class="stats-icon-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-card-left">
        <span class="stats-label">Active Jobs</span>
        <span class="stats-value"> {{ stats.activeJobs }}</span>
        <!-- <span class="stats-trend trend-neutral">
          {{ dashboardData?.active_jobs?.delta || 0 }}
          {{ dashboardData?.active_jobs?.delta_label }}
        </span> -->
      </div>
      <div class="stats-icon-wrapper text-blue">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-card-left">
        <span class="stats-label">Applications Received</span>
        <span class="stats-value"> {{ stats.applicationsReceived }}</span>
        <!-- <span class="stats-trend trend-positive">
          +{{ dashboardData?.applications_received?.delta || 0 }}
          {{ dashboardData?.applications_received?.delta_label }}
        </span> -->
      </div>
      <div class="stats-icon-wrapper text-indigo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-card-left">
        <span class="stats-label">Interview TAKEN</span>
        <span class="stats-value"> {{ stats.interviewsCompleted }}</span>
        <!-- <span class="stats-trend trend-neutral">
          {{ dashboardData?.interviews_completed?.delta || 0 }}
          {{ dashboardData?.interviews_completed?.delta_label }}
        </span> -->
      </div>
      <div class="stats-icon-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-card-left">
        <span class="stats-label">Assessments TAKEN</span>
        <span class="stats-value"> {{ stats.assessmentsConducted }}</span>
        <!-- <span class="stats-trend trend-positive">
          {{ dashboardData?.assessments_conducted?.delta || 0 }}
          {{ dashboardData?.assessments_conducted?.delta_label }}
        </span> -->
      </div>
      <div class="stats-icon-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      </div>
    </div>

    <div class="stats-card">
      <div class="stats-card-left">
        <span class="stats-label">Shortlisted Candidates</span>
        <span class="stats-value"> {{ stats.shortlistedCandidates }}</span>
        <!-- <span class="stats-trend trend-neutral">
          {{ dashboardData?.shortlisted_candidates?.delta || 0 }}
          {{ dashboardData?.shortlisted_candidates?.delta_label }}
        </span> -->
      </div>
      <div class="stats-icon-wrapper text-green">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <polyline points="16 11 18 13 22 9" />
        </svg>
      </div>
    </div>
  </section>

  <div class="dashboard-grid">
    <div class="grid-card">
      <div class="grid-card-header">
        <h3 class="grid-card-title">Recent Jobs</h3>
      </div>
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Type</th>
              <th>Applications</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let job of recentJobs">
              <td class="font-bold job-title-cell">
                <span class="job-title-text" [title]="job.job_title">{{ job.job_title }}</span>
              </td>
              <td>{{ job.job_type }}</td>
              <td class="center-align highlight">
                {{ job.applications_count || "0" }}
              </td>
              <td>
                <span
                  class="status-pill"
                  [ngClass]="{
                    'pill-active': job.status?.toLowerCase() === 'active',
                    'pill-closed':
                      job.status?.toLowerCase() === 'closed' ||
                      job.status?.toLowerCase() === 'rejected',
                    'pill-pending': job.status?.toLowerCase() === 'pending',
                    'pill-draft': job.status?.toLowerCase() === 'draft',
                  }"
                >
                  {{ job.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Recent Applications Block -->
    <div class="grid-card">
      <div class="grid-card-header">
        <h3 class="grid-card-title">Recent Applications</h3>
      </div>
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Role</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let app of recentApplications">
              <td>
                <div class="candidate-meta-cell">
                  <span class="candidate-name">{{ app.name }}</span>
                  <span class="candidate-email">{{ app.email }}</span>
                </div>
              </td>
              <td>{{ app.role }}</td>
              <td>{{ app.date }}</td>
              <td>
                <span
                  class="status-pill"
                  [ngClass]="{
                    'pill-active': app.status === 'Shortlisted',
                    'pill-applied': app.status === 'Applied',
                    'pill-interview': app.status === 'Interview',
                    'pill-closed': app.status === 'Rejected',
                  }"
                >
                  {{ app.status }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
